import { forwardRef, useImperativeHandle, useState } from "react"
import { Modal } from "@mui/material"
import EmailForm from "../../Email/EmailForm"
import ModalCloseButton from "../ModalCloseButton"

const EmailModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <ModalCloseButton handleClose={handleClose} />
        <EmailForm />
      </div>
    </Modal>
  )
})

export default EmailModal
